import React from "react";
import { useTranslation } from "react-i18next";
import { Widget } from "@typeform/embed-react";
import { FormCard } from "@/components/FormCard";
import { constants } from "@/constants";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const LiveEventSubmit = () => {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();

  return (
    <FormCard
      title={t("editEvent.liveEvent.cardTitle")}
      description={t("editEvent.liveEvent.cardDescription")}
      className="w-full max-w-5xl"
      previousButton={{
        label: t("global.previous"),
        onClick: () => navToRoute("editEvent"),
        variant: "outline",
      }}
      cancelButton={{
        label: t("global.cancel"),
        onClick: () => navToRoute("communityTools"),
        variant: "outline",
      }}
    >
      {constants?.TYPEFORM_LIVE_EVENTS_ID && (
        <div className="relative my-10 h-[450px] min-h-[450px] w-full overflow-hidden">
          <Widget
            id={constants.TYPEFORM_LIVE_EVENTS_ID}
            className="h-full w-full"
            onSubmit={() => navToRoute("communityTools")}
          />
        </div>
      )}
    </FormCard>
  );
};
